/**
 * @desc 订单可退运费查询
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export type Response = defs.omsFlow.ResponseDto<number>;
export function request(soOrderNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/asRefundOrder/refundSpShipping/${soOrderNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
